// @ts-strict-ignore
const toXCase = (_case) => (str) => {
  const strMatch =
    str &&
    str.trim() &&
    str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
  return strMatch && strMatch.map((x) => x.toLowerCase()).join(_case)
}

export const toKebabCase = toXCase('-')
export const toSnakeCase = toXCase('_')

export const toCamelCase = (str: string): string => {
  str = str.replace(/[^A-Za-z0-9 ]/g, '')

  str =
    str &&
    str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
      .join('')

  return str.slice(0, 1).toLowerCase() + str.slice(1)
}

export const capitalizeFirstLetter = (str: string): string => {
  str = str.replace(/[^A-Za-z0-9 ]/g, '')

  return str && str.charAt(0).toUpperCase() + str.slice(1)
}

export const leftPad = (str: string, length = 3, char = '0') => String(str).padStart(length, char)
